import * as React from 'react';

import { ITheme } from '@fluentui/react/lib/Styling';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import {
  AppPreviewGallery,
  AppPreviewGalleryInternalProps,
  AppPreviewGalleryProps,
  AppPreviewGalleryStoreOnlyProps,
  getAppGalleryStyles,
} from '@1js/acui-gallery';
import { AppThemeConsumer } from '@1js/acui-theme';

import { RibbonControlInternalProps } from '../../RibbonControlProps';
import { RibbonTableGalleryButton } from './RibbonTableGalleryButton';
import { GetTableStylingCallback, RibbonTableStylesGalleryButtonProps } from './RibbonTableGalleryButton.Props';
import {
  getTableStylesPreviewGalleryButtonStyles,
  getTableStylesPreviewGalleryStyles,
} from './RibbonTableStylesGallery.styles';

export type RibbonTableStylesPreviewGalleryInternalProps = RibbonTableStylesPreviewGalleryProps &
  AppPreviewGalleryInternalProps<RibbonTableStylesGalleryButtonProps> &
  RibbonControlInternalProps;

export interface RibbonTableStylesPreviewGalleryProps
  extends AppPreviewGalleryProps<RibbonTableStylesGalleryButtonProps> {
  type: 'RibbonTableStylesPreviewGalleryProps';

  /**
   * A function which provides the styling for the gallery buttons
   */
  getTableStyling?: GetTableStylingCallback;
}

export type withoutTableStylesPreviewGalleryStoreProps<T extends RibbonTableStylesPreviewGalleryProps> = Omit<
  T,
  keyof AppPreviewGalleryStoreOnlyProps
>;
export type RibbonTableStylesPreviewGalleryInheritedProps = withoutTableStylesPreviewGalleryStoreProps<RibbonTableStylesPreviewGalleryProps>;

export const TableCellContent: string = '—';

const getRibbonPreviewTableStylesGalleryButton = memoizeFunction(
  (
    getTableStyling: GetTableStylingCallback | undefined
  ): React.StatelessComponent<RibbonTableStylesGalleryButtonProps> =>
    React.memo((props: RibbonTableStylesGalleryButtonProps) => {
      const tableStylesPreviewButtonProps = {
        ...props,
        tableCellContent: TableCellContent,
        getTableStyling: getTableStyling || getTableStylesPreviewGalleryButtonStyles,
      };

      return (
        <RibbonTableGalleryButton
          {...tableStylesPreviewButtonProps}
          title={undefined}
          label={props.title}
          ariaLabel={props.title}
          shouldTakeFocus={props.shouldTakeFocus !== undefined ? props.shouldTakeFocus : true}
        />
      );
    })
);

class RibbonTablePreviewGallery extends AppPreviewGallery<RibbonTableStylesGalleryButtonProps> {}

export class RibbonTableStylesPreviewGallery extends React.PureComponent<
  RibbonTableStylesPreviewGalleryInternalProps,
  {}
> {
  public render() {
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <RibbonTablePreviewGallery
            {...this.props}
            styles={getAppGalleryStyles(theme, getTableStylesPreviewGalleryStyles(theme, this.props.styles))}
            getGalleryButtonComponent={getRibbonPreviewTableStylesGalleryButton(this.props.getTableStyling)}
            onGalleryButtonExecute={this.props.onGalleryButtonExecute}
            automationType="RibbonPreviewTableStylesGallery"
            uniqueId={this.props.id}
            persistMenu={true}
          />
        )}
      </AppThemeConsumer>
    );
  }
}
